/*** IMPORTS FROM imports-loader ***/
var global = window;

export default function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
